/** @format */

import {InvoicesList} from './invoices_list/invoices_list';
import {SearchContext} from 'frontier-search';
import {Loading, If} from 'frontier-utilities';
import {
    ActiveOrdersContextProvider,
    useActiveOrdersContext
} from './active_orders_context_provider';
import React, {useContext} from 'react';

const Container = () => {
    const ctx = useContext(SearchContext);
    const {state} = useActiveOrdersContext();
    const {carts, loading} = state;

    if (loading) {
        return <Loading height="200px" />;
    }

    if (!carts) {
        <div className="alert alert-info">
            It appears you do not have any active orders.{' '}
            <a href="/orders/custom-labels">Order Now!</a>
        </div>;
    }

    return (
        <If condition={carts?.length > 0}>
            <InvoicesList />
        </If>
    );
};

export default function ActiveOrders() {
    return (
        <ActiveOrdersContextProvider>
            <Container />
        </ActiveOrdersContextProvider>
    );
}
